// Root application component with routing

import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Layout from '@/components/Layout'
import RecordPage from '@/pages/RecordPage'
import FeedPage from '@/pages/FeedPage'
import VideoPage from '@/pages/VideoPage'
import AdminPage from '@/pages/AdminPage'

export default function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<RecordPage />} />
          <Route path="/feed" element={<FeedPage />} />
          <Route path="/video/:id" element={<VideoPage />} />
          <Route path="/cache-status" element={<AdminPage />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  )
}
